<template>
  <div id="editCard">
    <Card class='editCardCont'>
      <Divider orientation="left" :style="{color:'rgba(0, 0, 0, 0.65)'}">基本设置</Divider>
      <Form ref="cardData" :model="cardData" :rules="cardRules" :label-width="120">
        <FormItem label="补卡规则名称" prop="reClockInRuleName">
          <Input prefix="ios-paper-plane" v-model="cardData.reClockInRuleName" placeholder="请输入补卡规则名称" :style="{width:'200px'}"></Input>
        </FormItem>
        <!--<FormItem label="是否启用" prop="isUse">-->
          <!--<i-switch size="large" v-model="cardData.isUse">-->
            <!--<span slot="open">是</span>-->
            <!--<span slot="close">否</span>-->
          <!--</i-switch>-->
        <!--</FormItem>-->
        <FormItem label="应用考勤组">
          <Button @click="getAttendance()" v-show="showButton">请选择</Button>
          <Button @click="finishSetAttendanceGroup()" v-show="showAttendance">确定</Button>
          <Input prefix="ios-paper-plane" v-model="cardData.attendanceGroupNames" placeholder="请选择应用考勤组" :style="{width:'200px'}"></Input>
          <div v-show="showAttendance">
            <groupList-com ref="group" :checked="this.cardData.attendanceGroupDOS" @setAttendance="setAttendance($event)"></groupList-com>
          </div>
        </FormItem>
        <Divider orientation="left" :style="{color:'rgba(0, 0, 0, 0.65)'}">补卡设置</Divider>
        <FormItem label="是否允许补卡" prop="isReClockIn">
          <i-switch size="large" v-model="cardData.isReClockIn">
            <span slot="open">是</span>
            <span slot="close">否</span>
          </i-switch>
        </FormItem>
        <div v-show="showReClockIn">
          <FormItem label="限制补卡次数">
            <Row>
              <Col span="4">
                <i-switch size="large" v-model="cardData.isReClockInTimes">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </Col>
              <Col span="20" v-show="cardData.isReClockInTimes">
                每月可提交 <InputNumber :min="0" :style="{width:'60px'}" size="small" v-model='cardData.reClockInTimes'></InputNumber>
                次补卡
              </Col>
            </Row>
          </FormItem>
          <FormItem label="限制补卡时间">
            <Row>
              <Col span="4">
                <i-switch size="large" v-model="cardData.isReClockInTime">
                  <span slot="open">是</span>
                  <span slot="close">否</span>
                </i-switch>
              </Col>
              <Col span="20" v-show="cardData.isReClockInTime">
                可申请过去 <InputNumber :min="0" :style="{width:'60px'}" size="small" v-model='cardData.reClockInTime'></InputNumber>
                天内的补卡
                <span class="notes">(填写0天，表示只能缺卡当天进行补卡)</span>
              </Col>
            </Row>
          </FormItem>
        </div>
        <Divider />
        <FormItem class='bottom'>
          <Button @click="handleReset()" class="button" size='large'>取消</Button>
          <Button type="primary" @click="handleSubmit('cardData')" class="button" size='large'>保存</Button>
        </FormItem>
      </Form>
    </Card>
  </div>
</template>
<script>
  import groupList from '@/components/management/personnel/attendanceGroups/groupCheckList.vue'
  import axios from 'axios'
  import { Message } from 'element-ui'
  export default {
    components: {
      'groupList-com': groupList
    },
    created() {
      this.initData();
    },
    data() {
      return {
        showAttendance: false,
        showButton: true,
        cardData: {
          id: 0,
          reClockInRuleName: '', //补卡规则名称
          isUse: true,
          isReClockIn: false, //是否允许补卡
          isReClockInTimes: false, //限制补卡规则次数
          isReClockInTime: false, //限制补卡时间
          reClockInTimes: 0,
          reClockInTime: 0,
          attendanceGroupDOS: [],
          attendanceGroupNames: ''
        },
        cardRules: {
          reClockInRuleName: [{
            required: true,
            message: '请填写补卡规则名称',
            trigger: 'blur'
          }]
        },
      }
    },
    computed: {
      showReClockIn: function () {
        return this.cardData.isReClockIn;
      }
    },
    methods: {
      initData() {
        this.cardData.id = this.$route.query.id;
        if (this.cardData.id) {
          //请求补卡规则详细数据
          axios({
            method: "get",
            url: "/api/reClockInRule/getReClockInRule/" + this.cardData.id,
            data: {
              id: this.cardData.id
            }
          }).then((res) => {
            this.cardData = res.data;
          }).catch((error) => {
            this.$Message.error({
              content: error.message,
              duration: 2
            });
          })
        }
      },
      handleSubmit(cardData) {
        if (!this.cardData.isReClockInTimes) {
          this.cardData.reClockInTimes = 0;
        }
        if (!this.cardData.isReClockInTime) {
          this.cardData.reClockInTime = 0;
        }
        this.$refs[cardData].validate((valid) => {
          if (valid) {
            axios({
              method: "post",
              url: "/api/reClockInRule/saveReClockInRule",
              data: this.cardData
            }).then(() => {
              Message({message: '保存成功', type: 'success'});
              this.$router.push({
                path: '/attendanceSettings/reClock'
              });
            }).catch((error) => {
              this.$Message.error({
                content: error.response.data.detail,
                duration: 3
              });
            })
          } else {
            this.$Message.error('请填写完整所需的信息！');
          }
        })
      },
      handleReset() {
        this.$router.back()
      },
      /**
       * 打开考勤组选择组件
       */
      getAttendance() {
        this.$refs.group.getAttendance();
        this.showButton = false;
        this.showAttendance = true;
      },
      /**
       * 选择考勤组时父组件相关组件联动
       * @param attendanceGroupDOS
       */
      setAttendance(attendanceGroupDOS) {
        let str = "";
        this.cardData.attendanceGroupDOS = attendanceGroupDOS;
        if (this.$refs.group.checkedItemNames != null) {
          this.$refs.group.checkedItemNames.forEach(attendanceGroup => {
            str += attendanceGroup + ","
          });
          this.cardData.attendanceGroupNames = str.substr(0, str.length - 1);
        } else {
          this.cardData.attendanceGroupNames = str;
        }
      },
      /**
       * 关闭考勤组选择组件
       */
      finishSetAttendanceGroup() {
        this.showAttendance = false;
        this.showButton = true;
      }
    }
  }
</script>
<style scoped>
  @import url("../common/layout.css");

  .notes {
    padding-left: 10px;
    color: #a3a4a6;
  }

  .top {
    padding: 10px 0 0 10px;
  }
</style>
